import React from "react"
import { OutboundLink } from 'gatsby-plugin-google-analytics'

export default () => (
  <div className="c-main-footer">
    <p className="c-main-footer__note">

      Built with{" "}

      <OutboundLink href="https://www.gatsbyjs.org" target="_blank" rel="noopener noreferrer">Gatsby</OutboundLink>

      {" "}and{" "}

      <OutboundLink href="https://reactjs.org" target="_blank" rel="noopener noreferrer">React</OutboundLink>

      . Hosted by{" "}

      <OutboundLink href="https://www.netlify.com/" target="_blank" rel="noopener noreferrer">Netlify</OutboundLink>
      
      . The code is open source and available at{" "}

      <OutboundLink href="https://github.com/jawford/www.jawford.com" target="_blank" rel="noopener noreferrer">Github</OutboundLink>

    </p>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/MainFooter.jsx